import React from 'react';
import Icon from '../../utils/icons';
import './TVAlertBanner.css';

function TVAlertBanner({ alerts }) {
  if (!alerts || alerts.length === 0) return null;

  const severityOrder = ['Extreme', 'Severe', 'Moderate', 'Minor'];
  const sortedAlerts = [...alerts].sort(
    (a, b) => severityOrder.indexOf(a.severity) - severityOrder.indexOf(b.severity)
  );

  return (
    <div className="tv-alert-banner">
      <div className="tv-alert-icon">
        <Icon name="alertTriangle" size={32} />
        <span className="alert-count">{alerts.length}</span>
      </div>
      
      <div className="tv-alert-content">
        <div className="tv-alert-marquee">
          {sortedAlerts.map((alert, index) => (
            <span key={index} className="tv-alert-item">
              <span className={`severity-badge ${alert.severity?.toLowerCase()}`}>
                {alert.severity}
              </span>
              <span className="alert-event">{alert.event}</span>
              <span className="alert-headline">{alert.headline}</span>
              {index < sortedAlerts.length - 1 && <span className="alert-divider">•</span>}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TVAlertBanner;